<h2>Media</h2>
<p class="demo-description">Demonstrates <code>upp-thumb</code> and <code>upp-image</code>.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" (click)="toggleShape()">Shape: {{ thumbShape }}</ion-button>
    <ion-button size="small" *ngFor="let c of colors" [color]="c" (click)="thumbColor = c">{{ c }}</ion-button>
</div>

<!-- upp-thumb demo -->
<div class="demo-section">
    <h3>upp-thumb (shape={{ thumbShape }})</h3>
    <div style="display: flex; flex-wrap: wrap; gap: 16px;">
        <div *ngFor="let t of thumbs" style="width: 120px;">
            <upp-thumb
                [title]="t.title"
                [color]="thumbColor"
                [shape]="thumbShape"
                [icon]="t.icon"
                (Select)="onThumbSelect(t.title)">
                <upp-thumb-top-left>
                    <ion-badge color="success" style="font-size: 10px;">NEW</ion-badge>
                </upp-thumb-top-left>
                <upp-thumb-top-right>
                    <ion-icon name="ellipsis-horizontal" color="light" style="font-size: 14px;"></ion-icon>
                </upp-thumb-top-right>
                <upp-thumb-bottom>
                    <ion-label style="font-size: 12px;">{{ t.title }}</ion-label>
                </upp-thumb-bottom>
            </upp-thumb>
        </div>
    </div>
</div>

<!-- upp-thumb with detail and foot -->
<div class="demo-section">
    <h3>upp-thumb with detail/foot</h3>
    <div style="display: flex; flex-wrap: wrap; gap: 16px;">
        <div style="width: 120px;">
            <upp-thumb
                title="With Detail"
                color="tertiary"
                [shape]="thumbShape"
                icon="information-circle-outline"
                detail="Extra info"
                foot="$9.99">
            </upp-thumb>
        </div>
        <div style="width: 120px;">
            <upp-thumb
                title="Card Mode"
                color="secondary"
                [shape]="thumbShape"
                icon="card-outline"
                card="card-value">
            </upp-thumb>
        </div>
    </div>
</div>

<!-- upp-image demo -->
<div class="demo-section">
    <h3>upp-image</h3>
    <div class="demo-controls">
        <ion-button size="small" (click)="toggleImageReadonly()">Readonly: {{ imageReadonly }}</ion-button>
    </div>
    <div style="width: 200px; height: 200px; border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; overflow: hidden;">
        <upp-image
            [readonly]="imageReadonly"
            src="https://picsum.photos/200"
            crheight="200"
            crwidth="200">
        </upp-image>
    </div>
</div>
